import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HelmetProvider } from 'react-helmet-async';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from '@apollo/client';
import { AuthProvider } from './contexts/JWTContexts';
import store from "./store";

import { client } from './graphql';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import "@fontsource/space-grotesk/400.css"; // Specify weight
import "@fontsource/space-grotesk/500.css"; // Specify weight
import "@fontsource/space-grotesk/600.css"; // Specify weight
import "@fontsource/space-grotesk/700.css"; // Specify weight

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <StyledEngineProvider injectFirst>
        <BrowserRouter>
          <AuthProvider>
            <ApolloProvider client={client}>
              <App />
            </ApolloProvider>
          </AuthProvider>
        </BrowserRouter>
      </StyledEngineProvider>
    </ReduxProvider>
  </HelmetProvider>
);
